<template>
  <!-- An opaque full-screen overlay laid out like the focus layout's page
       (layouts/focus.vue): the same card, paddings and spacings, without the
       back button. Attributes (model-value, persistent, z-index…) go to v-overlay. -->
  <v-overlay :scrim="pageColor" opacity="1" class="sheet-overlay">
    <div class="sheet-overlay__page d-flex flex-column" :class="`bg-${pageColor}`">
      <div class="pt-md-16">
        <!-- the focus layout's header strip: on phones it pads the notch -->
        <header v-if="display.smAndDown.value" class="bg-neutral0 pt-8 pt-sm-2 px-2" />

        <v-container class="sheet-container py-0" :style="{ '--maxWidth': `${maxWidthDesktop}px` }">
          <v-card flat v-bind="subpageProps" class="subpage-content mt-md-6 py-2 py-md-10 mb-6">
            <v-container class="max-app-width full-height px-4 pt-12 pt-md-3">
              <slot />
            </v-container>
          </v-card>
        </v-container>
      </div>
    </div>
  </v-overlay>
</template>

<script setup>
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

defineProps({
  maxWidthDesktop: {
    type: Number,
    default: 720,
  },
})

const display = useDisplay()

// the focus layout's card, as it builds it: rounded on desktop, edge to edge on phones
const subpageProps = computed(() => (display.mdAndUp.value ? { class: 'rounded-lg', outlined: true } : { tile: true }))
// ...on its page colour: grey behind the card on desktop, white on phones
const pageColor = computed(() => (display.mdAndUp.value ? 'neutral25' : 'neutral0'))
</script>

<style lang="scss" scoped>
// the overlay's content is the page: full size, scrolling when the sheet is taller
.sheet-overlay :deep(.v-overlay__content) {
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.sheet-overlay__page {
  min-height: 100%;
}

.subpage-content {
  border-color: rgb(var(--v-theme-neutral50)) !important;
  background-color: rgb(var(--v-theme-neutral0));
}

.sheet-container {
  max-width: var(--maxWidth);
}
</style>
